<template>
    <vue-scroll class="lists-scroll">
        <div class="lists-container">
            <div class="list-column">
                <h3 class="list-title">List 1</h3>
                <special-events
                    :form="form"
                    :newsletter="newsletter"
                    @input="onInput"
                />
            </div>
            <div class="list-column">
                <h3 class="list-title">List 2</h3>
                <additional-list
                    :form="form"
                    :newsletter="newsletter"
                    @input="onInput"
                />
            </div>
        </div>
    </vue-scroll>
</template>

<script>
import AdditionalList from "./AdditionalList";
import SpecialEvents from "./SpecialEvents";

export default {
    components: {
        SpecialEvents,
        AdditionalList
    },
    props: {
        form: {
            type: Object,
            required: true
        },
        newsletter: {
            type: Object,
            required: true
        }
    },
    methods: {
        onInput() {
            this.$emit("typing-activity");
        }
    }
};
</script>

<style scoped>
/* Target the vue-scroll container */
:deep(.lists-scroll .ps-container) {
    width: 100% !important;
    max-width: 1200px !important;
}

.lists-container {
    display: flex;
    justify-content: flex-start; /* Change from center to flex-start */
    width: 100%;
    gap: 40px;
    margin: 0 auto;
    
}

.list-column {
    width: 100%;
    max-width: 600px;
    min-width: 0; /* Allow content to shrink if needed */
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 20px;
    margin-left: 0; /* Remove left margin if it's causing offset */
    border: 1px solid #eaeaea;
}

.list-title {
    margin-bottom: 20px;
    padding-left: 5px;
    color: #333;
    font-size: 18px;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 10px;
}

/* Override any table styles from child components */
:deep(table) {
    width: 100%;
}

:deep(th) {
    text-align: left;
    padding: 8px 5px;
    color: #606266;
}

:deep(td) {
    padding: 5px;
}

:deep(.el-input) {
    width: 100%;
}

/* Make responsive for smaller screens */
@media (max-width: 1024px) {
    .lists-container {
        flex-direction: column;
        align-items: center;
    }
    
    .list-column {
        width: 100%;
        max-width: 500px;
        margin: 0 auto 20px auto;
    }
}
</style>
